import * as React from "react";
import { makeStyles, Checkbox, Dropdown, Label, Option, Text } from "@fluentui/react-components";

interface SigningOptionsProps {
  outputFormat: string;
  onOutputFormatChange: (format: string) => void;
  sendImmediately: boolean;
  onSendImmediatelyChange: (value: boolean) => void;
}

var OUTPUT_FORMAT_LABELS: Record<string, string> = {
  PDF: "PDF",
  ASICE: "ASiCE",
  EDOC: "EDOC",
  ADOC_B: "ADOC-B",
};

const useStyles = makeStyles({
  sectionTitle: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    color: "#6b7280",
    marginBottom: "12px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    rowGap: "4px",
    marginBottom: "12px",
  },
});

const SigningOptions: React.FC<SigningOptionsProps> = ({
  outputFormat,
  onOutputFormatChange,
  sendImmediately,
  onSendImmediatelyChange,
}) => {
  const styles = useStyles();

  return (
    <div>
      <Text className={styles.sectionTitle} block>
        Options
      </Text>
      <div className={styles.fieldGroup}>
        <Label htmlFor="outputFormat" size="small">
          Output format
        </Label>
        <Dropdown
          id="outputFormat"
          value={OUTPUT_FORMAT_LABELS[outputFormat] || outputFormat}
          onOptionSelect={(_, data) => onOutputFormatChange(data.optionValue as string)}
        >
          <Option value="PDF">PDF</Option>
          <Option value="ASICE">ASiCE</Option>
          <Option value="EDOC">EDOC</Option>
          <Option value="ADOC_B">ADOC-B</Option>
        </Dropdown>
      </div>
      <Checkbox
        checked={sendImmediately}
        onChange={(_, data) => onSendImmediatelyChange(data.checked === true)}
        label="Send out immediately"
      />
    </div>
  );
};

export default SigningOptions;
